import { SVGIcon } from '@progress/kendo-svg-icons';
import { CONTENT_TYPE_FIELD, DOC_ID_FIELD } from '../../../config/consts';
import { GearSearchExportRequest } from '../../../Model/GearSearchExportRequest';

export enum ActionItemId {
  GROUP = 'group',
  ADD_NEW = 'addNew',
  EDIT = 'edit',
  DOWNLOAD = 'download',
  EXPORT = 'export',
  LOCK = 'lock',
  UNLOCK = 'unlock',
  DELETE = 'delete',
  NO_ACTIONS = 'noActions'
}

export interface DropDownButtonItem {
  id: ActionItemId;
  text: string;
  svgIcon: SVGIcon;
  groupId: string;
  isHidden?: boolean;
  className?: string;
}

export const CONFIRM_DIALOG = {
  MAX_EXPORT_ITEMS: 'MAX_EXPORT_ITEMS',
  TOO_MANY_REQUESTS: 'TOO_MANY_REQUESTS'
};

export const ACTION_GROUPS = {
  DOCUMENT_GROUP: 'documentGroup',
  GRID_GROUP: 'gridGroup'
};

export type ConfirmDialogType = (typeof CONFIRM_DIALOG)[keyof typeof CONFIRM_DIALOG];

export interface EditedDocument {
  [CONTENT_TYPE_FIELD]: string;
  [DOC_ID_FIELD]: string;
}

export interface TooManyRequestsTimer {
  querySearchExport: GearSearchExportRequest;
  timeLeft: number;
}
